import FJFontArrayBufferManager from './FJFontArrayBufferManager';
import FJFontManager from './FJFontManager';
import FJCommonWorkerStore from '../../store/FJCommonWorkerStore';
import FJArrayUtil from '../../util/FJArrayUtil.js';

class FJFontBase64Manager {
    constructor() {
        this._worker = null;
        this._dataMap = new Map();
        this._loadingSet = new Set();
    }

    /**
     *
     * @param {object} fontData
     * @param {*} fontData.fontName
     * @param {*} fontData.bold
     * @param {*} fontData.italic
     * @param {*} fontData.fontPath
     * @param {*} fontData.text
     * @param {*} fontData.glyphs
     * @return {Promise<*>}
     */
    async getFontBase64(fontData, fontBuffer) {
        const glyphsArray = fontData.glyphs
            ? fontData.glyphs.filter(value => value.trim() !== '')
            : fontData.text.replace(/\s+/g, '').replace(/\n/g, '').split('');

        let glyphs = FJArrayUtil.uniq(glyphsArray);
        // if (glyphs.length === 0) {
        //     throw new Error('No valid glyphs');
        // }

        const key = this._getFontDataKey(fontData);
        // await FJUtil.polling(() => FJFontArrayBufferManager.hasFontNameData() && !this._loadingSet.has(key), 50, 60000);

        if (this._dataMap.has(key)) {
            const { isAllGlyphs, glyphs: cacheGlyphs, base64 } = this._dataMap.get(key);
            if (isAllGlyphs || glyphs.every(value => cacheGlyphs.includes(value))) {
                return { base64, isAllGlyphs, glyphs };
            }

            // 有缓存的字体，但是缓存的字体不包含所有的字形，需要重新创建字体
            glyphs = FJArrayUtil.uniq([...glyphs, ...cacheGlyphs]);
        }

        try {
            this._loadingSet.add(key);

            let fontArrayBuffer = fontBuffer || (await FJFontArrayBufferManager.getFontArrayBuffer(fontData));
            if (!fontArrayBuffer) {
                fontArrayBuffer = await FJFontArrayBufferManager.createFontArrayBuffer(fontData);
            }
            if (!fontArrayBuffer) {
                throw new Error('No valid fontArrayBuffer');
            }

            const targetGlyphs = [...glyphs, ' '];
            const { isAllGlyphs, base64 } = await FJCommonWorkerStore.createFontBase64(fontArrayBuffer, targetGlyphs);

            if (!base64) {
                throw new Error("Can't create base64");
            }

            if (this._dataMap.has(key)) {
                if (isAllGlyphs) {
                    this._dataMap.set(key, { isAllGlyphs, base64 });
                } else {
                    this._dataMap.set(key, { base64, glyphs, isAllGlyphs: false });
                }
            } else {
                this._dataMap.set(key, { isAllGlyphs, base64, glyphs });
            }

            return { base64, isAllGlyphs, glyphs };
            // eslint-disable-next-line no-useless-catch
        } catch (e) {
            throw e;
        } finally {
            this._loadingSet.delete(key);
        }
    }

    _getFontDataKey(fontData) {
        const { fontName, bold, italic, fontPath } = fontData;

        if (fontPath) {
            return fontPath;
        }

        const { disableBold, disableItalic } = FJFontManager.fontStyleDisableData(fontName);
        const boldStr = bold && !disableBold ? 'bold' : 'normal';
        const italicStr = italic && !disableItalic ? 'italic' : 'normal';
        return `${fontName}-${boldStr}-${italicStr}`;
    }
}

let _instance = new FJFontBase64Manager();
export default _instance;
